module.exports = __webpack_public_path__ + "static/media/swiper_button_right.1d96b5a4.svg";